import React from 'react';
import { ROUTES } from '../../../constants';

function InStoreSummaryLink() {
  return (
    <a
      data-automation-id="backToInstoreSummary"
      className="u__default-link"
      href={ROUTES.PATH.AUTH_IN_STORE_TRACKING}
    >
      Back to In-Store Orders
    </a>
  );
}

export default InStoreSummaryLink;
